import { QuoteItem, QuoteStatus, QuoteType } from '../../common/types/quotes';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

interface IsFnaQuoted {
  isSuretyshipQuoted: boolean;
  isKeypersonQuoted: boolean;
  isBuyAndSellQuoted: boolean;
}

/**
 * Hook to check if a FNA has been quoted
 * @param fnaID FNA ID to check
 */
export const useIsFnaQuoted = (fnaID: number): IsFnaQuoted => {
  const { data: quotes } = useQuery<QuoteItem[]>({
    queryKey: ['/FNAQuoteLists', { fnaID }],
  });

  /**
   * Check if needs of the given type are quoted
   */
  const isTypeQuoted = (types: QuoteType[]): boolean =>
    quotes?.some(
      ({ typeID, statusID }) =>
        types.includes(typeID) && [QuoteStatus.Quoted, QuoteStatus.Incomplete].includes(statusID),
    ) || false;

  const isSuretyshipQuoted = isTypeQuoted([QuoteType.suretyship]);
  const isKeypersonQuoted = isTypeQuoted([QuoteType.keyperson]);
  const isBuyAndSellQuoted = isTypeQuoted([
    QuoteType.buyAndSellAlternative,
    QuoteType.buyAndSellShareBuyBack,
    QuoteType.buyAndSellTraditional,
  ]);

  return useMemo(
    () => ({
      isSuretyshipQuoted,
      isKeypersonQuoted,
      isBuyAndSellQuoted,
    }),
    [isBuyAndSellQuoted, isKeypersonQuoted, isSuretyshipQuoted],
  );
};
